(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hybrid-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var query = window.matchMedia('(prefers-reduced-motion: reduce)');
    function apply() {
      document.querySelectorAll('.hybrid-hero__video').forEach(function (video) {
        if (query.matches) {
          video.removeAttribute('autoplay');
          video.pause();
        } else if (video.paused) {
          var played = video.play();
          if (played && played.catch) played.catch(function () {});
        }
      });
    }
    apply();
    if (query.addEventListener) query.addEventListener('change', apply);
    document.addEventListener('shopify:section:load', apply);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    const DESKTOP_BREAKPOINT = 1024
    let isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT

    function initTimeline() {
      const yearButtons = document.querySelectorAll('.timeline__year-button')
      const entries = document.querySelectorAll('.timeline__entry')
      const scrubber = document.querySelector('.timeline__scrubber')
      const waveformWrapper = document.querySelector(
        '.timeline__waveform-wrapper'
      )
      const waveformContainer = document.querySelector(
        '.timeline__waveform-container'
      )
      const yearsContainer = document.querySelector('.timeline__years')

      if (!yearButtons.length || !entries.length) return

      function switchToYear(targetYear) {
        yearButtons.forEach(btn => {
          btn.dataset.active =
            btn.dataset.year === targetYear ? 'true' : 'false'
        })

        entries.forEach(entry => {
          const isActive = entry.dataset.entry === targetYear
          entry.dataset.active = isActive ? 'true' : 'false'
        })
      }

      function updateScrubberPosition(mouseX) {
        if (!scrubber || !waveformContainer || !isDesktop) return

        const waveformRect = waveformContainer.getBoundingClientRect()
        const position = mouseX - waveformRect.left

        // Always update position, even if slightly outside bounds
        scrubber.style.left = `${Math.max(0, Math.min(position, waveformRect.width))}px`
      }

      function getYearFromPosition(mouseX) {
        if (!yearsContainer || !waveformContainer) return null

        const waveformRect = waveformContainer.getBoundingClientRect()
        const yearsRect = yearsContainer.getBoundingClientRect()

        // Calculate mouse position relative to waveform
        const relativeX = mouseX - waveformRect.left
        const waveformWidth = waveformRect.width

        // Get year button positions
        const yearPositions = []
        yearButtons.forEach(btn => {
          const btnRect = btn.getBoundingClientRect()
          const btnCenter = btnRect.left - yearsRect.left + btnRect.width / 2
          yearPositions.push({
            button: btn,
            position: btnCenter,
            year: btn.dataset.year
          })
        })

        // Sort by position
        yearPositions.sort((a, b) => a.position - b.position)

        // Map mouse position on waveform to years container
        const yearsWidth = yearsRect.width
        const mappedPosition = (relativeX / waveformWidth) * yearsWidth

        // Find which year zone we're in
        for (let i = 0; i < yearPositions.length; i++) {
          const current = yearPositions[i]
          const next = yearPositions[i + 1]

          if (!next) {
            // Last year - if we're past halfway to it
            if (
              mappedPosition >=
              current.position -
                (current.position - (yearPositions[i - 1]?.position || 0)) / 2
            ) {
              return current.button
            }
          } else {
            // Check if we're in this year's zone
            const zoneBoundary = (current.position + next.position) / 2
            if (mappedPosition < zoneBoundary) {
              return current.button
            }
          }
        }

        return yearPositions[0]?.button || null
      }

      function showScrubber() {
        if (!scrubber) return
        scrubber.classList.add('active')
      }

      function hideScrubber() {
        if (!scrubber) return
        scrubber.classList.remove('active')
      }

      // Desktop: Track mouse movement over entire waveform wrapper area
      if (
        isDesktop &&
        waveformWrapper &&
        waveformContainer &&
        yearsContainer &&
        scrubber
      ) {
        // Main scrubbing interaction - scrubber follows mouse and switches year
        waveformWrapper.addEventListener('mousemove', e => {
          updateScrubberPosition(e.clientX)
          showScrubber()

          // Get the year button for this position and switch to it
          const targetButton = getYearFromPosition(e.clientX)
          if (targetButton && targetButton.dataset.year) {
            switchToYear(targetButton.dataset.year)
          }
        })

        // Years container continuous scrubbing - scrubber follows and switches
        yearsContainer.addEventListener('mousemove', e => {
          updateScrubberPosition(e.clientX)
          showScrubber()

          // Get the year button for this position and switch to it
          const targetButton = getYearFromPosition(e.clientX)
          if (targetButton && targetButton.dataset.year) {
            switchToYear(targetButton.dataset.year)
          }
        })

        // Only hide when leaving the entire wrapper area
        waveformWrapper.addEventListener('mouseleave', () => {
          hideScrubber()
        })
      }

      // All screen sizes: Click/tap and keyboard interactions
      yearButtons.forEach(button => {
        // Desktop: Hover over individual year button
        if (isDesktop) {
          button.addEventListener('mouseenter', () => {
            const buttonRect = button.getBoundingClientRect()
            const buttonCenter = buttonRect.left + buttonRect.width / 2
            updateScrubberPosition(buttonCenter)
            showScrubber()
            switchToYear(button.dataset.year)
          })
        }

        // Click/tap to switch year (works on all devices)
        button.addEventListener('click', () => {
          switchToYear(button.dataset.year)
        })

        // Keyboard support
        button.addEventListener('keydown', e => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault()
            const next = button.nextElementSibling
            if (next) {
              switchToYear(next.dataset.year)
              next.focus()
            }
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault()
            const prev = button.previousElementSibling
            if (prev) {
              switchToYear(prev.dataset.year)
              prev.focus()
            }
          }
        })
      })

      // Initialize first year on all screen sizes
      if (yearButtons.length > 0) {
        switchToYear(yearButtons[0].dataset.year)
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTimeline)
    } else {
      initTimeline()
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
